import data from "../../.sourceflow/popular_roles.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const popular_roles_helper = new CollectionHelper(data);
